import { ShellLink } from "@/src/components";
import NextImage from "../../NextImage";
import EdgenDrawer, { EdgenDrawerProps } from "../../Drawer";

export type ReasoningList = {
  url: string;
  title: string;
  description: string;
  favicon?: string;
};

interface RelevantModalProps extends EdgenDrawerProps {
  urls: ReasoningList[];
}

export const RelevantModal = ({
  isOpen,
  onClose,
  urls,
}: RelevantModalProps) => {
  return (
    <EdgenDrawer isOpen={isOpen} onClose={onClose} title="Relevant web pages">
      <div className="flex flex-col gap-[10px]">
        {urls?.map((item, index) => (
          <ShellLink
            aria-label="Relevant Modal"
            data-openreplay-label={`Relevant Modal Link | ${item.url}`}
            id="lnk-relevant-modal"
            key={item.url + index}
            href={item.url}
            target="_blank"
            className="p-3 rounded-2xl bg-background_white_overlay5 flex flex-col gap-3"
          >
            <div className="flex flex-col gap-2">
              <div className="text-content_primary body_medium_l">
                {item.title}
              </div>
              <div className="text-content_tertiary body_s line-clamp-5">
                {item.description}
              </div>
            </div>
            <div className="flex gap-1">
              <NextImage
                src={item.favicon}
                alt={item.title}
                placeholderSrc="/assets/images/globe_web_icon.png"
                className="w-4 h-4"
              />
              <div className="text-content_tertiary body_s flex-1 truncate">
                {item.url}
              </div>
            </div>
          </ShellLink>
        ))}
      </div>
    </EdgenDrawer>
  );
};
